import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'

export const MediaPlaceholder = () => (
  <Box
    width='100%'
    height='100%'
    align='center'
    justifyContent='center'
    padding={{ horizontal: 'smd' }}
  >
    <Icon name='camera' size={32} color='white' />
  </Box>
)
